import React, { useMemo, useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const ReadOnlyQuill = ({ delta, html, style = {} }) => {
  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  const content = useMemo(() => {
    if (delta) {
      try {
        let parsedDelta = delta;
        // Parse if it's a string
        while (typeof parsedDelta === 'string') {
          parsedDelta = JSON.parse(parsedDelta);
        }
        return parsedDelta;
      } catch (err) {
        console.error('Failed to parse delta:', err);
        return null;
      }
    }
    return null;
  }, [delta]);

  useEffect(() => {
    if (quillRef.current && !quillInstance.current) {
      // Create Quill instance in read-only mode
      quillInstance.current = new Quill(quillRef.current, {
        readOnly: true,
        modules: {
          toolbar: false,
        },
        theme: 'snow'
      });

      // Set content based on what's available
      if (content) {
        quillInstance.current.setContents(content);
      } else if (html) {
        quillInstance.current.root.innerHTML = html;
      }
    }

    // Update content when props change
    if (quillInstance.current) {
      if (content) {
        quillInstance.current.setContents(content);
      } else if (html) {
        quillInstance.current.root.innerHTML = html;
      }
    }
  }, [content, html]);

  return (
    <div 
      ref={quillRef} 
      style={{
        minHeight: '60px',
        border: '1px solid #ddd',
        borderRadius: '4px',
        backgroundColor: '#fafafa',
        ...style
      }}
    />
  );
};

export default ReadOnlyQuill;
